import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "insights",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "unit-planner" */ "./components"),
        import(
          /* webpackChunkName: "unit-planner" */ "./modules/InsightsModule"
        ),
        import(
          /* webpackChunkName: "unit-planner" */ "Post/modules/PostModule"
        ),
        import(
          /* webpackChunkName: "unit-planner" */ "Journal/modules/JournalModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const post = importedModule2.default;
          const journalReducer = importedModule3.default;
          injectReducer(store, {
            key: "insights",
            reducer,
          });
          injectReducer(store, {
            key: "post",
            reducer: post,
          });
          injectReducer(store, {
            key: "journal",
            reducer: journalReducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
});
